var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FED702"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.857 14.276l-.025.004a2.33 2.33 0 0 1-1.663 0c-.073-.026-.129.056-.078.103c.232.214.55.347.91.347c.334.005.659-.118.908-.343c.042-.043.008-.111-.048-.111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.516 13.642a1 1 0 0 0-.03-.1l-2.597-6.925a3 3 0 0 0-1.689-1.68a3.18 3.18 0 0 0-2.331 0h-.005a2.98 2.98 0 0 0-1.693 1.684l-2.54 6.6a2.29 2.29 0 0 0 .75 2.773c.042.03.076.06.11.099l.056.051l2.846 2.512a2.477 2.477 0 0 0 3.283 0l2.845-2.512q.145-.13.275-.278a2.4 2.4 0 0 0 .776-1.714a2.5 2.5 0 0 0-.056-.51m-4.114 3.677c-.382.3-.87.681-1.402.681s-1.02-.381-1.401-.681a.21.21 0 0 1-.086-.172a.21.21 0 0 1 .086-.171a2.28 2.28 0 0 1 2.807 0a.214.214 0 0 1 0 .343zm2.142-1.98l-1.397 1.341a.34.34 0 0 1-.437.026a2.83 2.83 0 0 0-1.71-.634a2.83 2.83 0 0 0-1.714.634a.33.33 0 0 1-.197.068a.33.33 0 0 1-.232-.094l-1.401-1.341a.304.304 0 0 1 .013-.459c.977-.823 2.22-1.166 3.531-1.166c1.316 0 2.559.343 3.536 1.166c.141.12.141.33.008.459m-.008-3.54c-.977.827-2.22 1.487-3.536 1.487s-2.554-.66-3.531-1.487a.304.304 0 0 1-.013-.459l1.397-1.341a.34.34 0 0 1 .437-.026c.484.377 1.08.741 1.71.741s1.226-.364 1.714-.741a.33.33 0 0 1 .429.026l1.401 1.341a.31.31 0 0 1-.008.459"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApex);
export default __webpack_public_path__ + "static/media/apex.373ddd2ca0c69d258b8b49b2dea48c38.svg";
export { ForwardRef as ReactComponent };